import axios from 'axios';

// `insertPause` deja la pausa de Orca para meter imanes, NFC o la arandela del
// abrebotellas. Va dentro del enlace firmado: Orca sólo recibe la URL.
export async function openModelInOrca(modelId, { expirationSeconds = 2 * 60, insertPause = true } = {}) {
    const { data } = await axios.post(`/customized-keyrings/${modelId}/3mf-orca-link/`, {
        expiration_seconds: expirationSeconds,
        insert_pause: insertPause ? 1 : 0,
    });

    const link = document.createElement('a');
    link.href = `orcaslicer://open?file=${encodeURIComponent(data.url)}`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return data;
}
